(function () {
  var MAX = 5;

  function handleFromHref(href) {
    var m = (href || '').match(/\/products\/([^?#/]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function build(handle) {
    var list = (window.CS_DATA || {})[handle];
    if (!list || list.length < 2) return null;
    var ul = document.createElement('ul');
    ul.className = 'cs-wrap cs-card';
    ul.setAttribute('role', 'list');
    list.slice(0, MAX).forEach(function (s) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = s.u;
      a.className = 'cs-dot' + (s.h === handle ? ' cs-active' : '');
      a.style.setProperty('--cs-col', s.c);
      a.title = s.n;
      a.setAttribute('aria-label', s.n);
      li.appendChild(a);
      ul.appendChild(li);
    });
    if (list.length > MAX) {
      var more = document.createElement('li');
      more.className = 'cs-more';
      more.textContent = '+' + (list.length - MAX);
      ul.appendChild(more);
    }
    return ul;
  }

  function process(root) {
    var cards = (root || document).querySelectorAll('.card-product:not([data-cs-done])');
    cards.forEach(function (card) {
      card.setAttribute('data-cs-done', '1');
      var link = card.querySelector('a.card-product--text-section-link');
      if (!link) return;
      var handle = handleFromHref(link.getAttribute('href'));
      var ul = build(handle);
      if (ul) link.insertAdjacentElement('afterend', ul);
    });
  }

  function init() {
    process(document);
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { process(document); }, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
